

import React from 'react';


import Strengths from './results-strengths';

import { strengthsText } from './../../text/strengths-text.js';

import PremiumLockbox from './premium-lockbox';

import { motion } from 'framer-motion';



const StrengthsTab = ({ personalityData, opeTitle, opeLogo, conTitle, conLogo, agrTitle,
    agrLogo, extTitle, extLogo, staTitle, staLogo, setPremiumModalOpen, isPaid }) => {

    let personalityDataExists = true;

    let showStrengths = true;


    let opeStrength1;
    let opeStrength2;

    let opeWeakness1;
    let opeWeakness2;



    if (personalityData == null) {
        personalityData = ({ "ope": 4, "con": 4, "ext": 4, "agr": 4, "sta": 4 });
        personalityDataExists = false;
    }

    const opeLevel = personalityData.ope;
    const conLevel = personalityData.con;
    const extLevel = personalityData.ext;
    const agrLevel = personalityData.agr;
    const staLevel = personalityData.sta;


    

    return (

        <motion.div className="result"
            initial={{ opacity: 0, y: -10 }}
            animate={
                { opacity: 1, y: 0, transition: { delay: 0.3 } }}
        >
            <>

                <h1 className="facet-title" >
                    <img className="facet-title-logo" src={opeLogo} alt="logo" />
                    <div>
                        {opeTitle}
                    </div>
                </h1>

                <Strengths trait={"o"} level={opeLevel} isPaid={isPaid} />

                {(isPaid == true) ?
                    <>
                       
                    </>
                    :
                    < PremiumLockbox setPremiumModalOpen={setPremiumModalOpen} modalText="Purchase the full test to unlock extended strengths and weaknesses results"/>
                }

                <hr />

                <h1 className="facet-title" >
                    <img className="facet-title-logo" src={conLogo} alt="logo" />
                    <div>
                        {conTitle}
                    </div>
                </h1>

                <Strengths trait={"c"} level={conLevel} isPaid={isPaid}/>


                {(isPaid == true) ?
                    <>
                       
                    </>
                    :
                    < PremiumLockbox setPremiumModalOpen={setPremiumModalOpen}  modalText="Purchase the full test to unlock extended strengths and weaknesses results" />
                }

                <div className="vertical-spacer" />
                <hr />


                <h1 className="facet-title" >
                    <img className="facet-title-logo" src={extLogo} alt="logo" />
                    <div>
                        {extTitle}
                    </div>
                </h1>


                <Strengths trait={"e"} level={extLevel} isPaid={isPaid}/>


                {(isPaid == true) ?
                    <>
                       
                    </>
                    :
                    < PremiumLockbox setPremiumModalOpen={setPremiumModalOpen}  modalText="Purchase the full test to unlock extended strengths and weaknesses results"/>
                }

                <div className="vertical-spacer" />
                <hr />

                <h1 className="facet-title" >
                    <img className="facet-title-logo" src={agrLogo} alt="logo" />
                    <div>
                        {agrTitle}
                    </div>
                </h1>

                <Strengths trait={"a"} level={agrLevel} isPaid={isPaid}/>


                {(isPaid == true) ?
                    <>
                      
                    </>
                    :
                    < PremiumLockbox setPremiumModalOpen={setPremiumModalOpen}  modalText="Purchase the full test to unlock extended strengths and weaknesses results"/>
                }

                <div className="vertical-spacer" />
                <hr />

                <h1 className="facet-title" >
                    <img className="facet-title-logo" src={staLogo} alt="logo" />
                    <div>
                        {staTitle}
                    </div>
                </h1>
                <Strengths trait={"s"} level={staLevel} isPaid={isPaid}/>


                {(isPaid == true) ?
                    <>
                       
                    </>
                    :
                    < PremiumLockbox setPremiumModalOpen={setPremiumModalOpen} modalText="Purchase the full test to unlock extended strengths and weaknesses results" />
                }

                <div className="vertical-spacer" />
                <hr />
                <></>
            </>

        </motion.div>
    );
}

export default StrengthsTab;